<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="800px">
    <v-card >
      <v-form ref="editForm" @submit.prevent="mode === 'edit' ? update() : add()">
        <v-toolbar card color="primary" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title v-if="mode === 'edit'">{{$t('companiesSettings.updateTitle')}}</v-toolbar-title>
          <v-toolbar-title v-else>{{$t('companiesSettings.addTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="mode === 'edit' && currentModel == null" class="text-xs-center">
          <v-progress-circular
            :width="6"
            :size="60"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex xs12>
                <v-text-field
                  :label="$t('companiesSettings.name')"
                  v-model="currentModel.name"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 >
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.level')"
                  v-model.number="currentModel.level"
                  :rules="[v => v >= 0 || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.productionCompany">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('companiesSettings.simulatedCompany')"
                  v-model="currentModel.simulatedCompany"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('companiesSettings.productionCompany')"
                  v-model="currentModel.productionCompany"
                ></v-switch>
              </v-flex>
              <v-flex xs12 v-if="currentModel.suppliers && currentModel.suppliers.length > 1">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('companiesSettings.assemblyMode')"
                  v-model="currentModel.assemblyMode"
                ></v-switch>
              </v-flex>
              <v-flex xs12 v-if="currentModel.simulatedCompany">
                <v-autocomplete
                  :label="$t('companiesSettings.demandProfile')"
                  item-text="name"
                  item-value="_id"
                  v-model="currentModel.demandProfile"
                  :items="$store.state.demandProfiles.list"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.productionCompany">
                <v-autocomplete
                  multiple
                  chips
                  deletable-chips
                  :label="$t('companiesSettings.suppliers')"
                  item-text="name"
                  item-value="_id"
                  v-model="currentModel.suppliers"
                  :items="filterSuppliers"
                  :rules="[v => v.length > 0 || $t('fields.required')]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany">
                <v-autocomplete
                  multiple
                  chips
                  deletable-chips
                  :label="$t('companiesSettings.clients')"
                  item-text="name"
                  item-value="_id"
                  v-model="currentModel.clients"
                  :items="filterClients"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany">
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.leadTime')"
                  v-model.number="currentModel.leadTime"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.productionCompany">
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.productionLeadTime')"
                  v-model.number="currentModel.productionLeadTime"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany">
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.initialStock')"
                  v-model.number="currentModel.initialStock"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany && !currentModel.productionCompany">
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.firstOrder')"
                  v-model.number="currentModel.firstOrder"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany && currentModel.productionCompany">
                <v-text-field
                  type="number"
                  :label="$t('companiesSettings.firstProduction')"
                  v-model.number="currentModel.firstProduction"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!currentModel.simulatedCompany && gameVersion.dd">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('companiesSettings.ddOn')"
                  v-model="currentModel.ddOn"
                ></v-switch>
              </v-flex>
              <v-flex xs6 v-if="mode === 'edit' && currentModel.logo">
                <v-card>
                  <v-toolbar card color="grey" dark dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{$t('companiesSettings.logo')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-img contain max-height="200px" :src="config.filesUrl + currentModel.instance + '/logo/' + currentModel.logo"></v-img>
                    <v-btn
                      color="primary"
                      block
                      @click.native="$refs.logoInput.click()"
                      :loading="$store.state.companies.loading"
                    >{{$t('companiesSettings.updateLogo')}}</v-btn>
                    <input
                      ref="logoInput"
                      type="file"
                      accept=".png, .jpeg, .jpg"
                      @change="uploadLogo($event)"
                      style="display:none"
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 v-if="mode === 'edit' && currentModel.logo">
                <v-card>
                  <v-toolbar card color="grey" dark dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{$t('companiesSettings.supplyPicture')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-img contain max-height="200px" height="200px" :src="config.filesUrl + currentModel.instance + '/logo/' + currentModel.supplyPicture"></v-img>
                    <v-btn
                      color="primary"
                      block
                      @click.native="$refs.supplyPictureInput.click()"
                      :loading="$store.state.companies.loading"
                    >{{$t('companiesSettings.updateSupplyPicture')}}</v-btn>
                    <input
                      ref="supplyPictureInput"
                      type="file"
                      accept=".png, .jpeg, .jpg"
                      @change="uploadSupplyPicture($event)"
                      style="display:none"
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="mode === 'edit'"
            color="primary"
            :loading="$store.state.companies.loading"
            submit
            flat
            type="submit"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            v-else
            color="primary"
            :loading="$store.state.companies.loading"
            type="submit"
            flat
          >{{$t('general.add')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.companies.loading"
            submit
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import Config from '@/config'
export default {
  name: "CompanyEdit",
  props: { active: Boolean, id: {}, mode: String },
  data() {
    return {
      show: false,
      rules: {
        required: value => !!value || this.$t('fields.required')
      },
      currentModel: {},
      gameVersion: {}
    };
  },
  methods: {
    async init() {
      let model = await this.$store.dispatch(
        "gameVersions/getOne",
        this.$route.params.id
      );
      this.gameVersion = Object.assign({}, model);
      this.$store.dispatch("demandProfiles/getAll");
      await this.$nextTick()
      this.$refs.editForm.reset();
      if (this.mode === 'edit') {
        this.getModel()
      } else {
        this.currentModel = {}
        await this.$nextTick()
        this.currentModel = Object.assign({}, this.$store.state.companies.model)
      }
    },
    async add() {
      if (this.$refs.editForm.validate()) {
        this.currentModel.gameVersion = this.$route.params.id
        if (await this.$store.dispatch("companies/add", this.currentModel)){
          this.$emit('closedialog')
        }
      }
    },
    async update() {
      if (this.$refs.editForm.validate()) {
        if (
          await this.$store.dispatch("companies/update", {
            id: this.id,
            data: this.currentModel
          })
        ) {
          this.$emit("closedialog");
        }
      }
    },
    async getModel() {
      this.currentModel = null
      let model = await this.$store.dispatch("companies/getOne", this.id);
      this.currentModel = Object.assign({}, model);
    },
    async uploadLogo(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let formData = new FormData();
      formData.append("logo", files[0]);
      if (
        await this.$store.dispatch("companies/uploadLogo", {
          id: this.currentModel._id.toString(),
          data: formData
        })
      ) {
        this.getModel();
      }
      this.$refs["logoInput"].value = "";
    },
    async uploadSupplyPicture(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let formData = new FormData();
      formData.append("logo", files[0]);
      if (
        await this.$store.dispatch("companies/uploadSupplyPicture", {
          id: this.currentModel._id.toString(),
          data: formData
        })
      ) {
        this.getModel();
      }
      this.$refs["supplyPictureInput"].value = "";
    }
  },
  computed: {
    config () {
      return Config
    },
    filterSuppliers () {
      return this.$store.state.companies.list.filter(company => {
          let available = true;
          if (this.currentModel.clients && this.currentModel.clients.length > 0) {
            for(var i = 0; i < this.currentModel.clients.length; i++) {
                if (this.currentModel.clients[i].toString() == company._id.toString()) {
                    available = false;
                    break;
                }
            }
            return available
          } else {
            return true
          }
        })
    },
    filterClients () {
      return this.$store.state.companies.list.filter(company => {
          let available = true;
          if (this.currentModel.suppliers && this.currentModel.suppliers.length > 0) {
            for(var i = 0; i < this.currentModel.suppliers.length; i++) {
                if (this.currentModel.suppliers[i].toString() == company._id.toString()) {
                    available = false;
                    break;
                }
            }
            return available
          } else {
            return true
          }
        })
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.init()
      }
    },
    "currentModel.productionCompany" (val) {
      if (val) {
        this.currentModel.suppliers = []
      }
    },
    "currentModel.simulatedCompany" (val) {
      if (val) {
        this.currentModel.clients = []
      }
    },
    "currentModel.suppliers" (val) {
      if (val && val.length < 2) {
        this.currentModel.assemblyMode = false
      }
    }
  }
};
</script>
